import React from 'react';
import styled from 'styled-components';

type Step = {
  label: string;
};

type Props = {
  steps: Step[];
  currentStep: number;
};

const OrderStepper: React.FC<Props> = ({ steps, currentStep }) => {
  return (
    <StepperContainer>
      {steps.map((step, index) => {
        const completed = index < currentStep;
        const active = index === currentStep;

        return (
          <StepItem key={index} active={active} completed={completed}>
            <StepCircle active={active} completed={completed}>
              {completed ? '✓' : index + 1}
            </StepCircle>
            <StepLabel>{step.label}</StepLabel>
          </StepItem>
        );
      })}
    </StepperContainer>
  );
};

const StepperContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.5rem 0;
`;

const StepItem = styled.div<{ active: boolean; completed: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    top: 14px;
    right: -50%;
    width: 100%;
    height: 2px;
    background: ${({ completed }) => (completed ? '#E99FAD' : '#ccc')};
    z-index: 0;
  }
`;

const StepCircle = styled.div<{ active: boolean; completed: boolean }>`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${({ completed, active }) =>
    completed ? '#E99FAD' : active ? '#FFCEC7' : '#eee'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ completed }) => (completed ? '#fff' : '#000')};
  font-weight: 600;
  z-index: 1;
`;

const StepLabel = styled.span`
  margin-top: 0.5rem;
  font-size: 0.8rem;
  text-align: center;
`;

export default OrderStepper;
